import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TvModel, TvAction } from "src/store";
import SimpleBar from "simplebar-react";
import { TvConductorListSearch } from "./tv.conductor.list.search";
import { TvConductorProgramCard } from "./tv.conductor.program.card";
import { TvConductorProgramCardShimmer } from "./tv.conductor.program.card.shimmer";
import { _ } from "src/services";

export const TvConductorList: React.FC<{
  listRef: React.RefObject<HTMLDivElement>;
  scrollRef: React.RefObject<any>;
}> = ({ listRef, scrollRef }) => {
  //#region Dependencies

  const dispatch = useDispatch();
  const conductor: TvModel = useSelector((state: any) => state.TvState);

  //#endregion

  //#region properites

  const filtered = conductor.conductor.filter(
    (x) => x.title.indexOf(conductor.searchText || "") > -1
  );

  //#endregion

  //#region methods

  const fetchData = useCallback(() => {
    if (!conductor.currentChannel) return;

    dispatch(
      TvAction.requestConductor(
        conductor.currentChannel,
        conductor.currentDate,
        ""
      )
    );
  }, [dispatch, conductor]);

  //#endregion

  //#region effcts

  useEffect(() => {
    if (conductor.currentChannel) {
      fetchData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conductor.currentChannel?.id]);

  useEffect(() => {
    if (scrollRef && scrollRef.current && !conductor.conductorLoading) {
      const current = conductor.conductor.find((x) => x.currentProgram);

      if (!current) return;

      const index = conductor.conductor.indexOf(current);
      //@ts-ignore
      scrollRef.current.contentWrapperEl.scroll(0, (index - 3) * 40);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conductor.conductor]);

  //#endregion

  //#region helpers

  const renderPrograms = () => {
    if (conductor.conductorLoading && !conductor.conductor.length) {
      return [...new Array(10)].map((item, index) => (
        <TvConductorProgramCardShimmer key={index} />
      ));
    }

    if (!conductor.channelsLoading && !filtered.length) {
      return (
        <div className="col-12 text-center text-rtl">
          <div className="no-result-title mt-2 mt-md-4 mb-5 mb-md-0">
            {_("noProgramMessage")}
          </div>
        </div>
      );
    }

    return filtered.map((item) => (
      <TvConductorProgramCard key={item.id} {...item} />
    ));
  };

  //#endregion

  return (
    <>
      <h1 className="title">
        {`${_("programList")}${
          conductor.currentChannel?.title
            ? "ی " + conductor.currentChannel?.title
            : ""
        }`}
      </h1>
      <TvConductorListSearch />
      <div className="scroll-area scroll" ref={listRef}>
        <SimpleBar style={{ maxHeight: "100%" }} ref={scrollRef}>
          {renderPrograms()}
        </SimpleBar>
      </div>
    </>
  );
};
